/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#2A4759',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const SubCategoryInitialValue = {
  Category_Id: null,
  MainCategory_Id: null,
  Category_Code: '',
  Category_Description: '',
  Active: 'Y',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const SubCategory = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [subCategoryTableData, setSubCategoryTableData] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [UserId, setUserId] = useState(null);
  const [initialValue, setInitialValue] = useState(SubCategoryInitialValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    GetAllSubCategory();
    GetAllMainCategories();
  }, []);

  const GetAllMainCategories = async () => {
    try {
      showLoading();
      const response = await axios.get('Master/MainCategory/GetAllMainCategory');
      setMainCategories(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const subCategoryValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        MainCategory_Id: Yup.object().required('Please select Main Category'),
        Category_Code: Yup.string().trim().nullable(),
        Category_Description: Yup.string()
          .trim()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Category Description')
          .test(
            'unique-combination',
            'This Main Category and Sub Category combination already exists',
            function (value) {
              const { MainCategory_Id } = this.parent;
              if (!MainCategory_Id || !value) return true;

              // Skip validation if we're in edit mode and the values haven't changed
              if (
                edit &&
                initialValue.MainCategory_Id?.MainCategory_Id === MainCategory_Id.MainCategory_Id &&
                initialValue.Category_Description?.toLowerCase() === value?.toLowerCase()
              ) {
                return true;
              }

              return !subCategories.some(
                (item) =>
                  item.MainCategory_Id === MainCategory_Id.MainCategory_Id &&
                  item.Category_Description?.toLowerCase() === value?.toLowerCase() &&
                  item.Category_Id !== initialValue.Category_Id
              );
            }
          ),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [subCategories, initialValue, edit] // Added 'edit' to dependencies
  );

  async function GetAllSubCategory() {
    try {
      showLoading();
      const response = await axios.get('Master/SubCategory/GetAllSubCategory');
      setSubCategories(response.data);
      setSubCategoryTableData(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertSubCategory(values) {
    try {
      const { MainCategory_Id, ...remainingValues } = values;
      showLoading();
      await axios.post('Master/SubCategory/InsertSubCategory', {
        ...remainingValues,
        MainCategory_Id: MainCategory_Id.MainCategory_Id,
        Created_By: UserId,
      });
      GetAllSubCategory();
      openSnackBar('Sub Category Added Successfully!');
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateSubCategory = async (values) => {
    try {
      const { MainCategory_Id, ...remainingValues } = values;
      showLoading();
      await axios.post(`Master/SubCategory/UpdateSubCategory`, {
        ...remainingValues,
        MainCategory_Id: MainCategory_Id.MainCategory_Id,
        Modify_By: UserId,
      });
      GetAllSubCategory();
      setInitialValue(SubCategoryInitialValue);
      openSnackBar('Sub Category Updated Successfully!', 'warning');
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteSubCategory = async () => {
    try {
      showLoading();
      await axios.delete(`Master/SubCategory/DeleteSubCategory/${deleteId}`);
      GetAllSubCategory();
      openSnackBar('Sub Category Deleted Successfully!', 'warning');
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const mainCategory = mainCategories.find((cat) => cat.MainCategory_Id === values.MainCategory_Id);
    setInitialValue({
      ...values,
      MainCategory_Id: mainCategory || null,
    });
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  useEffect(() => {
    const newTableData = subCategories.filter(
      (subCat) =>
        `${subCat.Category_Description} ${subCat.MainCategory_Description} ${subCat.Category_Code}`
          .toLowerCase()
          .includes(filterData.searchTerm?.toLowerCase()) && subCat.Active === (filterData.Active ? 'Y' : 'N')
    );
    if (page > 0) setPage(0);
    setSubCategoryTableData(newTableData);
  }, [subCategories, filterData]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(SubCategoryInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = subCategoryTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [subCategoryTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: '#2A4759',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              SUB CATEGORY MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add Sub Category
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Main Category</StyledTableCell>
                <StyledTableCell align="left">Sub Category</StyledTableCell>
                <StyledTableCell align="center">Category Code</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? subCategoryTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : subCategoryTableData
              ).map((subCategory, i) => (
                <TableRow key={subCategory.Category_Id} hover>
                  <TableCell align="center">{subCategory.SNo}</TableCell>
                  <TableCell align="left">{subCategory.MainCategory_Description}</TableCell>
                  <TableCell align="left">{subCategory.Category_Description}</TableCell>
                  <TableCell align="center">{subCategory.Category_Code}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={subCategory.Active === 'Y' ? 'success' : 'error'}
                      label={subCategory.Active === 'Y' ? 'Yes' : 'No'}
                      size="small"
                      variant="outlined"
                      icon={subCategory.Active === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(subCategory);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(subCategory.Category_Id);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'sm'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} Sub Category
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={subCategoryValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateSubCategory(values);
                    else await InsertSubCategory(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={mainCategories}
                            size="small"
                            getOptionLabel={(option) => option.MainCategory_Description}
                            isOptionEqualToValue={(option, value) => option.MainCategory_Id === value?.MainCategory_Id}
                            value={values.MainCategory_Id}
                            onChange={(event, newValue) => {
                              setFieldValue('MainCategory_Id', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Main Category"
                                required
                                error={touched.MainCategory_Id && !!errors.MainCategory_Id}
                                helperText={touched.MainCategory_Id && errors.MainCategory_Id}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Category Code (Optional)"
                            type="text"
                            name="Category_Code"
                            onBlur={handleBlur}
                            error={touched.Category_Code && !!errors.Category_Code}
                            helperText={touched.Category_Code && errors.Category_Code}
                            value={values.Category_Code}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Sub Category Description"
                            name="Category_Description"
                            onBlur={handleBlur}
                            error={touched.Category_Description && !!errors.Category_Description}
                            helperText={touched.Category_Description && errors.Category_Description}
                            value={values.Category_Description}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <FormControl size="small" fullWidth component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup row value={values.Active} name="Active" onChange={handleChange}>
                              <FormControlLabel value="Y" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="N" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography variant="caption" color="error">
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteSubCategory} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default SubCategory;
